const SignatoryFooter = ({
  signatoryName = "",
  signatoryDesignation = "",
  brand = "AUROBIL CARS",
  acceptanceLabel = "Customer Acceptance",
}) => {
  const hasIdentity = Boolean(signatoryDesignation)

  return (
    <table className="pdf-w-100">
      <tbody>
        <tr>
          <td className="pdf-w-50">
            <table className="pdf-table-py-2">
              <tbody>
                <tr>
                  <td>Sincerely,</td>
                </tr>
                {hasIdentity ? (
                  <>
                    {signatoryName && (
                      <tr>
                        <td>{signatoryName}</td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        {signatoryDesignation} of{" "}
                        <span className="pdf-brand">{brand}</span>
                      </td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <td>
                      <span className="pdf-brand">{brand}</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
          <td className="pdf-w-50 pdf-vb pdf-text-center">{acceptanceLabel}</td>
        </tr>
      </tbody>
    </table>
  )
}

export default SignatoryFooter
